import { render, staticRenderFns } from "./LgOrderPanel.vue?vue&type=template&id=763637dc&scoped=true&"
import script from "./LgOrderPanel.vue?vue&type=script&lang=js&"
export * from "./LgOrderPanel.vue?vue&type=script&lang=js&"
import style0 from "./LgOrderPanel.vue?vue&type=style&index=0&id=763637dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763637dc",
  null
  
)

export default component.exports